import React, { useEffect, useMemo, useRef, useState } from "react";
import "swiper/css";
import { Swiper, SwiperSlide, useSwiperSlide } from "swiper/react";
import { featuredVideos } from "../../assets/content/data";
import ImageLoader from "../image/ImageLoader";

const borderColors = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

const FeaturedVideo = React.memo(
  ({ item, videoIndex, borderColor, swiperInstance, userInteracted }) => {
    const swiperSlide = useSwiperSlide();
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPlayedBefore, setIsPlayedBefore] = useState(false);

    const handleExitFullscreen = () => {
      setIsPlaying(false);
      videoRef.current?.pause();
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.controls = false;
        videoRef.current.removeAttribute("controls");
      }
    };

    useEffect(() => {
      if (swiperSlide.isActive && userInteracted) {
      } else {
        videoRef.current?.pause();
        setIsPlaying(false);
      }

      const videoElement = videoRef.current;

      const exitFullscreenHandler = () => {
        handleExitFullscreen();
      };

      videoElement?.addEventListener(
        "webkitendfullscreen",
        exitFullscreenHandler
      );
      videoElement?.addEventListener("fullscreenchange", exitFullscreenHandler);

      return () => {
        videoElement?.removeEventListener(
          "webkitendfullscreen",
          exitFullscreenHandler
        );
        videoElement?.removeEventListener(
          "fullscreenchange",
          exitFullscreenHandler
        );
      };
    }, [swiperSlide.isActive, userInteracted]);

    const handlePlay = (isClickedOnBtn) => {
      if (!swiperSlide.isActive) {
        swiperInstance?.slideToLoop(videoIndex, 500);
        swiperInstance?.update();
      }
      if (isPlaying) {
        videoRef.current?.pause();
        setIsPlaying(false);
      } else {
        if (isClickedOnBtn) {
          videoRef.current
            ?.play()
            .then(() => {
              setIsPlaying(true);
              setIsPlayedBefore(true);
            })
            .catch(() => {});
        }
      }
    };

    return (
      <div
        className="featured-video-container"
        style={{ borderColor, borderWidth: swiperSlide.isActive ? 4 : 2 }}
      >
        <div
          className={`featured-video-wrapper position-relative ${
            swiperSlide.isActive ? "active-video" : ""
          }`}
        >
          <video
            className="featured-video featured-video-thumbnail"
            poster={item.thumbnail}
            onClick={() => handlePlay(false)}
            ref={videoRef}
            onEnded={handleExitFullscreen}
            controls={false}
            style={{ zIndex: isPlaying || isPlayedBefore ? 1 : 0 }}
          >
            <source src={item.video} type="video/mp4" />
          </video>
          <ImageLoader
            placeHolderImage={item.placeHolder}
            src={item.thumbnail}
            alt={item.name}
            className="featured-video-thumbnail"
          />
          <div
            className="position-absolute top-0 start-0 d-flex align-items-center featured-profile-details"
            style={{ zIndex: 2 }}
          >
            <img
              src={item.profile}
              alt={item.name}
              height={23}
              width={23}
              className="featured-profile-img"
            />
            <div>
              <p className="text-white fs-6 fw-bold m-0">{item.name}</p>
              <p className="text-white fs-6 fw-regular m-0">{item.job}</p>
            </div>
          </div>
          <button
            style={{ zIndex: 2 }}
            className={`position-absolute top-50 start-50 translate-middle-video bg-transparent border-0 p-0 fade-button ${
              isPlaying ? "fade-out" : "fade-in"
            }`}
            onClick={() => handlePlay(true)}
          >
            <PlayIcon color={"#FA004D"} />
          </button>
        </div>
      </div>
    );
  }
);

const FeaturedIn = () => {
  const swiperRef = useRef(null);
  const [userInteracted, setUserInteracted] = useState(false);

  const handleUserInteraction = () => {
    if (!userInteracted) {
      setUserInteracted(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleUserInteraction, { once: true });
    document.addEventListener("touchstart", handleUserInteraction, {
      once: true,
    });

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
  }, [userInteracted]);

  const swiperInstance = useMemo(() => swiperRef.current, [swiperRef.current]);

  return (
    <>
      <div className="payment-padding-x black-background ">
        <p className="text-center text-white fs-24 open-sans-800 payment-section-b">
          FEATURED IN
        </p>
        <div className="d-flex justify-content-around align-items-center w-100 mb-5 mt-4">
          <Forbes />
          <BusinessInsider />
        </div>
      </div>

      <div className="w-100 featured-slider-wrapper position-relative">
        <div className="d-flex justify-content-center align-items-end position-absolute top-0 end-0 me-2 translate-middle-y">
          <div className="mb-2 me-1">
            <SmallHeartIcon />
          </div>
          <HeartIcon />
        </div>
        <div className="featured-circle position-absolute start-0 translate-middle-x">
          {/* <CircleIcon /> */}
        </div>

        <Swiper
          ref={swiperRef}
          spaceBetween={5}
          slidesPerView={2.7}
          loop={true}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
        >
          {featuredVideos.map((video, index) => (
            <SwiperSlide key={index} virtualIndex={index}>
              <FeaturedVideo
                key={index}
                item={video}
                videoIndex={index}
                borderColor={borderColors[index % borderColors.length]}
                swiperInstance={swiperInstance}
                userInteracted={userInteracted}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="d-flex justify-content-end align-items-center gap-3 me-3 mt-3">
          <button
            className="featured-scroll-btn"
            onClick={() => swiperRef.current?.slidePrev(500)}
          >
            <div className="d-flex align-items-center">
              <ArrowIcon />
            </div>
          </button>
          <button
            className="featured-scroll-btn rotate-180"
            onClick={() => swiperRef.current?.slideNext(500)}
          >
            <div className="d-flex align-items-center">
              <ArrowIcon />
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default FeaturedIn;

const BusinessInsider = () => (
  <svg
    id="Business_Insider_logo"
    data-name="Business Insider logo"
    xmlns="http://www.w3.org/2000/svg"
    width="103"
    height="32"
    viewBox="0 0 103 32"
  >
    <path
      id="Path_83"
      data-name="Path 83"
      d="M7.984,32h2.4V19.2h-2.4Zm8.783-.192h2.146V23.732L27.946,32V19.392h-2.14V27.33L16.767,19.2Zm16.078-3.1a6.594,6.594,0,0,0,4.073,1.436c1.464,0,2.491-.5,2.491-1.617,0-.97-.655-1.35-1.8-1.775l-1.857-.645c-1.712-.608-3.014-1.5-3.014-3.537,0-2.183,1.971-3.37,4.328-3.37a7.154,7.154,0,0,1,3.788,1.006v2.165a6.075,6.075,0,0,0-3.742-1.334c-1.294,0-2.261.483-2.261,1.49,0,.91.607,1.274,1.676,1.64l2.069.726c2.005.7,2.925,1.8,2.925,3.6,0,2.262-1.99,3.511-4.6,3.511a7.5,7.5,0,0,1-4.073-1.086V28.708ZM47.109,32h2.4V19.2h-2.4ZM60.74,30.063c2.7,0,4.143-1.732,4.143-4.466,0-2.754-1.444-4.48-4.143-4.48H58.07v8.946h2.67ZM55.89,19.2h4.93c3.795,0,6.249,2.5,6.249,6.4S64.615,32,60.82,32H55.89Zm23.157,0v1.917h-5.8V24.2h5.2v1.9h-5.2v3.971h5.8V32H71.062V19.2Zm8.5,5.8h2.377a1.973,1.973,0,1,0,0-3.919H87.549V25Zm0,1.81V32H85.434V19.2h4.532c2.584,0,4.256,1.331,4.256,3.837,0,2.143-.928,3.374-2.9,3.69L95.814,32H93.408l-4.354-5.193h-1.5ZM7.147,6.59A2.828,2.828,0,0,0,8.814,3.8c0-2.358-1.667-3.58-4.334-3.58H0V13.386H4.9c2.667,0,4.334-1.308,4.334-3.773A3.179,3.179,0,0,0,7.147,6.59ZM2.1,5.754v-3.6H4.46c1.48,0,2.271.536,2.271,1.779S5.939,5.754,4.46,5.754H2.1ZM2.1,7.6h2.75c1.46,0,2.251.728,2.251,1.929,0,1.179-.792,1.93-2.25,1.93H2.1V7.6Zm16.9,6c3.063,0,5.126-1.844,5.126-5.445V.223H21.964V7.9c0,2.53-1.042,3.71-2.959,3.71s-2.958-1.18-2.958-3.71V.223H13.88v7.91c0,3.623,2.083,5.467,5.125,5.467Zm10.228-1.158A7.147,7.147,0,0,0,33.3,13.6c2.6,0,4.584-1.33,4.584-3.73,0-1.908-.916-3.066-2.917-3.816L32.9,5.282c-1.063-.385-1.667-.771-1.667-1.736,0-1.072.958-1.586,2.25-1.586a5.832,5.832,0,0,1,3.73,1.415V1.08A6.766,6.766,0,0,0,33.442.009c-2.354,0-4.313,1.265-4.313,3.58,0,2.165,1.292,3.108,3,3.751l1.855.686c1.146.45,1.792.858,1.792,1.887,0,1.179-1.021,1.715-2.48,1.715a6.346,6.346,0,0,1-4.063-1.522v2.336ZM45.623.223H43.457V13.385h2.166Zm6.182,13.146h2.088V4.806l8.788,8.767V.2H60.6V8.62L51.805,0V13.369ZM76.222.226V2.2H70.6V5.365h5.045V7.314H70.6V11.4h5.626v1.992h-7.75V.226Zm5.045,12.207a7.145,7.145,0,0,0,4.063,1.158c2.6,0,4.584-1.329,4.584-3.73C89.914,7.953,89,6.8,87,6.045l-2.063-.771c-1.063-.386-1.667-.772-1.667-1.737,0-1.072.958-1.586,2.25-1.586a5.837,5.837,0,0,1,3.73,1.415V1.072A6.758,6.758,0,0,0,85.475,0c-2.354,0-4.313,1.265-4.313,3.58,0,2.165,1.292,3.108,3,3.751l1.855.686c1.146.45,1.792.858,1.792,1.887,0,1.179-1.02,1.715-2.48,1.715A6.335,6.335,0,0,1,81.267,10.1v2.336Zm13.086,0a7.147,7.147,0,0,0,4.063,1.158c2.605,0,4.584-1.329,4.584-3.73,0-1.908-.917-3.065-2.917-3.816L98.02,5.274c-1.062-.386-1.667-.772-1.667-1.737,0-1.072.959-1.586,2.25-1.586a5.835,5.835,0,0,1,3.73,1.415V1.072A6.752,6.752,0,0,0,98.562,0c-2.355,0-4.313,1.265-4.313,3.58,0,2.165,1.292,3.108,3,3.751l1.855.686c1.146.45,1.792.858,1.792,1.887,0,1.179-1.021,1.715-2.48,1.715A6.34,6.34,0,0,1,94.353,10.1v2.336Z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);

const Forbes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="103.566"
    height="25.983"
    viewBox="0 0 103.566 25.983"
  >
    <path
      id="Forbes_logo"
      d="M59.71,10.469c0-3.032.052-5.855.209-8.469l-8,1.516v.732l.784.1a1.443,1.443,0,0,1,1.15.575A4.626,4.626,0,0,1,54.325,6.6c.1,1.516.209,4.967.157,10.4,0,5.385-.052,8.783-.157,10.09a33.033,33.033,0,0,0,6.8.889,9.786,9.786,0,0,0,7.371-2.719,10.073,10.073,0,0,0,2.719-7.371,9.193,9.193,0,0,0-2.039-6.117,6.41,6.41,0,0,0-5.123-2.4A10.228,10.228,0,0,0,59.71,10.469Zm.157,16.1c-.1-1.673-.209-6.692-.209-14.9a6.022,6.022,0,0,1,1.882-.261,3.3,3.3,0,0,1,2.98,1.934,9.7,9.7,0,0,1,1.1,4.862,13.418,13.418,0,0,1-1.255,6.117c-.836,1.621-1.882,2.457-3.189,2.457a9.758,9.758,0,0,0-1.307-.209ZM21.912,2.523H1V3.568l1.1.1a2.779,2.779,0,0,1,1.778.941A4.859,4.859,0,0,1,4.5,7.123a99.355,99.355,0,0,1,0,15.788,6.188,6.188,0,0,1-.627,2.509,2.383,2.383,0,0,1-1.778.941L1,26.519v1.046H14.488V26.519l-1.412-.1a2.562,2.562,0,0,1-1.778-.941,4.859,4.859,0,0,1-.627-2.509c-.157-2.091-.261-4.5-.261-7.162l2.823.052c1.516.052,2.562,1.2,3.084,3.5h1.046V10.835H16.318c-.523,2.248-1.516,3.4-3.084,3.45l-2.823.052c0-4.705.1-8.051.261-10.09H14.8c2.928,0,4.914,1.882,6.064,5.646l1.255-.366Zm-2.457,16.1a10.044,10.044,0,0,0,2.3,6.744c1.516,1.778,3.764,2.614,6.587,2.614a8.787,8.787,0,0,0,6.8-2.719A9.413,9.413,0,0,0,37.6,18.52a10.044,10.044,0,0,0-2.3-6.744C33.779,10,31.531,9.162,28.708,9.162a8.787,8.787,0,0,0-6.8,2.719,9.413,9.413,0,0,0-2.457,6.744Zm11.658-5.96A15.8,15.8,0,0,1,32,18.573c0,5.542-1.15,8.26-3.4,8.26q-1.725,0-2.666-2.353a16.163,16.163,0,0,1-.889-5.908c0-5.489,1.15-8.208,3.4-8.208C29.6,10.312,30.486,11.1,31.113,12.665Zm44.176,12.7a8.907,8.907,0,0,0,6.535,2.614,8.8,8.8,0,0,0,4.287-.993,7.87,7.87,0,0,0,2.928-2.353l-.523-.627a6.262,6.262,0,0,1-3.973,1.307,5.729,5.729,0,0,1-4.81-2.091,7.73,7.73,0,0,1-1.568-5.489H89.353a9.468,9.468,0,0,0-1.934-6.169,6.751,6.751,0,0,0-5.489-2.353,8.6,8.6,0,0,0-6.8,2.771,9.788,9.788,0,0,0-2.4,6.744,8.943,8.943,0,0,0,2.562,6.64Zm3.869-13.122c.575-1.255,1.307-1.882,2.3-1.882,1.568,0,2.353,1.987,2.353,6.012l-5.542.1a10.929,10.929,0,0,1,.889-4.235Zm24.258-2.091a13.114,13.114,0,0,0-5.333-.993,7.841,7.841,0,0,0-5.228,1.673,5.147,5.147,0,0,0-1.987,4.078,4.465,4.465,0,0,0,1.2,3.294,9.906,9.906,0,0,0,3.66,2.039,9.941,9.941,0,0,1,3.032,1.516,2.595,2.595,0,0,1,0,3.816,2.8,2.8,0,0,1-2.2.836c-2.3,0-4.026-1.673-5.228-5.019l-.889.261.209,5.228a17.179,17.179,0,0,0,6.274,1.1,8.591,8.591,0,0,0,5.594-1.621,5.323,5.323,0,0,0,2.039-4.444,4.56,4.56,0,0,0-.993-3.084,8.568,8.568,0,0,0-3.346-2.091,13.068,13.068,0,0,1-3.555-1.725,2.4,2.4,0,0,1-.941-1.934,2.738,2.738,0,0,1,.68-1.934,2.222,2.222,0,0,1,1.777-.732c2.091,0,3.607,1.516,4.548,4.5l.889-.261ZM53.123,9.685a5.235,5.235,0,0,0-2.4-.523,4.7,4.7,0,0,0-2.771,1.1,7.065,7.065,0,0,0-2.3,3.084L45.7,9.162l-7.946,1.568v.732l.784.052c.993.1,1.568.889,1.673,2.3a57,57,0,0,1,0,10.351c-.1,1.412-.68,2.143-1.673,2.3l-.784.1v.993H48.836v-.993l-1.412-.1c-.993-.1-1.568-.889-1.673-2.3a53.407,53.407,0,0,1-.1-9.619,2.519,2.519,0,0,1,2.039-.941,5.919,5.919,0,0,1,3.5.941l1.934-4.862Z"
      transform="translate(-1 -2)"
      fill="#fff"
    />
  </svg>
);

const HeartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48.607"
    height="43.341"
    viewBox="0 0 48.607 43.341"
  >
    <path
      id="Icon_akar-heart"
      data-name="Icon akar-heart"
      d="M15.152,4.5A12.092,12.092,0,0,0,3,16.53c0,5.364,2.127,18.094,23.059,30.962a2.394,2.394,0,0,0,2.489,0C49.48,34.624,51.607,21.894,51.607,16.53A12.092,12.092,0,0,0,39.455,4.5c-6.71,0-12.152,7.291-12.152,7.291S21.862,4.5,15.152,4.5Z"
      transform="translate(-3 -4.5)"
      fill="#c520cb"
    />
  </svg>
);

const SmallHeartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.107"
    height="21.496"
    viewBox="0 0 24.107 21.496"
  >
    <path
      id="Icon_akar-heart"
      data-name="Icon akar-heart"
      d="M9.027,4.5A6,6,0,0,0,3,10.467c0,2.66,1.055,8.974,11.437,15.356a1.187,1.187,0,0,0,1.234,0c10.382-6.382,11.437-12.7,11.437-15.356A6,6,0,0,0,21.081,4.5c-3.328,0-6.027,3.616-6.027,3.616S12.355,4.5,9.027,4.5Z"
      transform="translate(-3 -4.5)"
      fill="#c520cb"
    />
  </svg>
);

const PlayIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
  >
    <circle cx="28" cy="28" r="28" fill="#fff" opacity="0.8" />
    <polygon points="22,14 22,42 42,28" fill={color} />
  </svg>
);
const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5.721"
    height="10.413"
    viewBox="0 0 5.721 10.413"
  >
    <path
      d="M12.971,11.4l3.786-3.937a.762.762,0,0,0,0-1.051.7.7,0,0,0-1.013,0l-4.29,4.461a.765.765,0,0,0-.021,1.026l4.308,4.492a.7.7,0,0,0,1.013,0,.762.762,0,0,0,0-1.051Z"
      transform="translate(-11.246 -6.196)"
      fill="#0097FA"
    />
  </svg>
);

export const CircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="108"
    height="164"
    viewBox="0 0 108 164"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_80"
          data-name="Rectangle 80"
          width="108"
          height="164"
          transform="translate(0 1119)"
          fill="#faf4fe"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_39"
      data-name="Mask Group 39"
      transform="translate(0 -1119)"
      clipPath="url(#clip-path)"
    >
      <circle
        id="Ellipse_61"
        data-name="Ellipse 61"
        cx="82"
        cy="82"
        r="82"
        transform="translate(-56 1119)"
        fill="#f4541a"
      />
    </g>
  </svg>
);
